import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  useTheme,
  useMediaQuery,
  Divider,
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Link, useLocation, useHistory } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ScienceIcon from "@mui/icons-material/Science";
import BallotIcon from "@mui/icons-material/Ballot";
import BusinessIcon from "@mui/icons-material/Business";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import RuleIcon from "@mui/icons-material/Rule";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PsychologyIcon from "@mui/icons-material/Psychology";
import BuildIcon from "@mui/icons-material/Build";
import SearchIcon from "@mui/icons-material/Search";
import TerrainIcon from "@mui/icons-material/Terrain";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { auth } from "../Config/firebase";
import { onAuthStateChanged } from "firebase/auth";


import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../Config/firebase";
import { getUsuarioAtualComTenant, tenantWhere } from "../Utils/tenant";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import { LOGO_NAVEGACAO } from "../Config/branding";

const drawerWidth = 260;
const AMBIENTE_LOCAL = typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

import { SIDEBAR_ITEMS } from "../Config/sidebarItems";
import { usePermissoesAcesso } from "../Utils/permissoesAcesso";
const menu = SIDEBAR_ITEMS.main;


export default function Sidebar({ open, toggle }) {
  const { podeAcessarItem } = usePermissoesAcesso();
 
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const tipoUsuario = (localStorage.getItem("tipoUsuario") || "").toLowerCase();
  const planoUsuario = (localStorage.getItem("planoUsuario") || "").toLowerCase();

 
  const [temPendencias, setTemPendencias] = useState(false);
  const [temSolicitacoesPendentes, setTemSolicitacoesPendentes] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openCadastrar, setOpenCadastrar] = useState(false);
  const [openEnsaiosDialog, setOpenEnsaiosDialog] = useState(false);
  const [categoriaEnsaios, setCategoriaEnsaios] = useState("concreto");
  const [buscaEnsaios, setBuscaEnsaios] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const ensaiosMenu = menu.find((item) => item.id === "ensaios");
  const ensaiosPermitidos = (ensaiosMenu?.children || []).filter((child) => {
    if (!Array.isArray(child.tiposPermitidos)) return true;
    return child.tiposPermitidos.includes(tipoUsuario);
  });
  const ensaiosFiltrados = ensaiosPermitidos.filter((ensaio) => {
    const termo = buscaEnsaios.trim().toLowerCase();
    const correspondeCategoria = termo ? true : (ensaio.categoria || "concreto") === categoriaEnsaios;
    const correspondeBusca = !termo || contemTextoPesquisa(String(ensaio.label || "").toLowerCase(), termo);
    return correspondeCategoria && correspondeBusca;
  });




            useEffect(() => {
                  if (tipoUsuario !== "admin") {
                    setTemPendencias(false);
                    return undefined;
                  }
                  let unsubscribe = () => {};
                  let cancelado = false;

                  async function ouvirAprovacoes() {
                    const usuario = await getUsuarioAtualComTenant();
                    if (cancelado) return;

                  const q = query(
                    collection(db, "aprovacoes"),
                    ...tenantWhere(usuario),
                    where("status", "==", "pendente")
                  );

                  unsubscribe = onSnapshot(
                    q,
                    (snap) => {
                      console.log("Aprovações pendentes:", snap.size);
                      setTemPendencias(!snap.empty);
                    },
                    (error) => {
                      console.error("ERRO AO OUVIR APROVACÕES:", error);
                      setTemPendencias(false);
                    }
                  );
                  }

                  ouvirAprovacoes().catch((error) => {
                    console.error("ERRO AO OUVIR APROVACÃ•ES:", error);
                    setTemPendencias(false);
                  });

                  return () => {
                    cancelado = true;
                    unsubscribe();
                  };
                }, [tipoUsuario]);

            useEffect(() => {
                  let unsubscribe = () => {};
                  let cancelado = false;

                  async function ouvirSolicitacoes() {
                    const usuario = await getUsuarioAtualComTenant();
                    if (cancelado) return;

                    const q = query(
                      collection(db, "tblSolicitacoesServicos"),
                      ...tenantWhere(usuario)
                    );

                  unsubscribe = onSnapshot(
                    q,
                    (snap) => {
                      const temPendente = snap.docs.some((docSnap) => {
                        const dados = docSnap.data();
                        if (dados.status === "pendente") return true;
                        return (dados.ensaios || []).some(
                          (ensaio) => (ensaio.status || "pendente") === "pendente"
                        );
                      });

                      setTemSolicitacoesPendentes(temPendente);
                    },
                    (error) => {
                      console.error("ERRO AO OUVIR SOLICITAÇÕES:", error);
                      setTemSolicitacoesPendentes(false);
                    }
                  );
                  }

                  ouvirSolicitacoes().catch((error) => {
                    console.error("ERRO AO OUVIR SOLICITAÃ‡Ã•ES:", error);
                    setTemSolicitacoesPendentes(false);
                  });

                  return () => {
                    cancelado = true;
                    unsubscribe();
                  };
                }, []);

useEffect(() => {
  const unsub = onAuthStateChanged(auth, async (user) => {
    if (!user) {
      setIsAdmin(false);
      return;
    }

    const token = await user.getIdTokenResult(true);
    setIsAdmin(token.claims.admin === true);
  });

  return () => unsub();
}, []);

  
  const handleLogout = () => {
    localStorage.clear();
    history.push("/");
  };

  const abrirEnsaio = (path) => {
    setOpenEnsaiosDialog(false);
    setBuscaEnsaios("");
    history.push(path);
    if (isMobile) toggle();
  };

  const itemTemAlerta = (item) =>
    (item.aprovacao === true && temPendencias) ||
    (item.id === "solicitacaoServicos" && temSolicitacoesPendentes);

  const renderMenuIcon = (item, color = "white") => {
    const Icone = itemTemAlerta(item) ? NotificationsActiveIcon : item.icon;
    if (!Icone) return null;

    const icone = <Icone />;
    return itemTemAlerta(item) ? (
      <Badge color="error" variant="dot">
        {icone}
      </Badge>
    ) : (
      icone
    );
  };

  const drawerContent = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* LOGO */}
      <Box
        sx={{
          p: 3,
          
          display: "flex",
          justifyContent: "center",
        }}
      >
        <LogoRelatorio
          logoPadrao={LOGO_NAVEGACAO}
          monocromaticaBranca={db?.app?.options?.projectId !== "qualinfra-sgq"}
          alt="Logo"
          style={{ width: 200, maxHeight: 72 }}
        />
      </Box>

      <Divider sx={{ background: "rgba(255,255,255,0.2)" }} />

      {isAdmin && (
        <>
          <List>
            {/* ADMIN */}
            <ListItemButton onClick={() => setOpenAdmin((prev) => !prev)}>
              <ListItemIcon sx={{ color: "#FFE082" }}>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Admin"
                primaryTypographyProps={{ color: "white", fontWeight: 700 }}
              />
              {openAdmin ? (
                <ExpandLessIcon sx={{ color: "white" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "white" }} />
              )}
            </ListItemButton>

            <Collapse in={openAdmin} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton component={Link} to="/admin-sgq" sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ color: "#C8E6C9" }}>
                    <RuleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Admin SGQ" />
                </ListItemButton>

                <ListItemButton component={Link} to="/lista-mestra" sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ color: "#B3E5FC" }}>
                    <ListAltIcon />
                  </ListItemIcon>
                  <ListItemText primary="Lista Mestra" />
                </ListItemButton>

                <ListItemButton component={Link} to="/admin/kpis" sx={{ pl: 4 }}>
                  <ListItemIcon sx={{ color: "#FFF9C4" }}>
                    <BarChartIcon />
                  </ListItemIcon>
                  <ListItemText primary="Admin KPIs" />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/admin/kpis/respostas"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#BBDEFB" }}>
                    <AssignmentTurnedInIcon />
                  </ListItemIcon>
                  <ListItemText primary="Pesquisas Respondidas" />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/admin/psicossocial/cadastro"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#E1BEE7" }}>
                    <PsychologyIcon />
                  </ListItemIcon>
                  <ListItemText primary="Cadastro Psicossocial" />
                </ListItemButton>
              </List>
            </Collapse>
          </List>

          {/* CADASTRAR */}
          <List>
            <ListItemButton onClick={() => setOpenCadastrar((prev) => !prev)}>
              <ListItemIcon sx={{ color: "#FFE082" }}>
                <AddHomeWorkIcon />
              </ListItemIcon>
              <ListItemText
                primary="Cadastrar"
                primaryTypographyProps={{ color: "white", fontWeight: 700 }}
              />
              {openCadastrar ? (
                <ExpandLessIcon sx={{ color: "white" }} />
              ) : (
                <ExpandMoreIcon sx={{ color: "white" }} />
              )}
            </ListItemButton>

            <Collapse in={openCadastrar} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  component={Link}
                  to="/app/cadastromateriais"
                  sx={{ pl: 4 }}
                >
                  
                  <ListItemIcon sx={{ color: "#FFF9C4" }}>
                    <BallotIcon />
                  </ListItemIcon>
                  <ListItemText primary="Materiais" />
                </ListItemButton>
                <ListItemButton
                    component={Link}
                    to="/app/cadastro-equipamentos"
                    sx={{ pl: 4 }}
                  >
                    <ListItemIcon sx={{ color: "#B2DFDB" }}>
                      <BuildIcon />
                    </ListItemIcon>
                    <ListItemText primary="Equipamentos" />
                  </ListItemButton>

            <ListItemButton
              component={Link}
              to="/app/clientes"
              sx={{ pl: 4 }}
            >
              <ListItemIcon sx={{ color: "#FFE082" }}>
                <BusinessIcon />
              </ListItemIcon>
              <ListItemText primary="Clientes" />
            </ListItemButton>
                <ListItemButton
                  component={Link}
                  to="/app/cadastroobras"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#C8E6C9" }}>
                    <AddHomeWorkIcon />
                  </ListItemIcon>
                  <ListItemText primary="Obras" />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/app/cadastro-concreteiras"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#B2DFDB" }}>
                    <BusinessIcon />
                  </ListItemIcon>
                  <ListItemText primary="Concreteiras" />
                </ListItemButton>

                <ListItemButton
                  component={Link}
                  to="/app/caixinha-empresa"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#C8E6C9" }}>
                    <AccountBalanceWalletIcon />
                  </ListItemIcon>
                  <ListItemText primary="Caixinha da Empresa" />
                </ListItemButton>
                
                            <ListItemButton
                              component={Link}
                              to="/app/departamento-pessoal"
                              sx={{ pl: 4 }}
                            >
                              <ListItemIcon sx={{ color: "#C5CAE9" }}>
                                <BusinessIcon />
                              </ListItemIcon>
                              <ListItemText primary="Departamento Pessoal" />
                            </ListItemButton>

                {planoUsuario !== "pessoal" && (
                  <ListItemButton
                    component={Link}
                    to="/app/cadastrousuarios"
                    sx={{ pl: 4 }}
                  >
                    <ListItemIcon sx={{ color: "#BBDEFB" }}>
                      <BusinessIcon />
                    </ListItemIcon>
                    <ListItemText primary="Usuários" />
                  </ListItemButton>
                )}

                <ListItemButton
                  component={Link}
                  to="/app/cadastrarlaudos"
                  sx={{ pl: 4 }}
                >
                  <ListItemIcon sx={{ color: "#E1BEE7" }}>
                    <DescriptionIcon />
                  </ListItemIcon>
                  <ListItemText primary="Laudos" />
                </ListItemButton>
              </List>
            </Collapse>
          </List>
        </>
      )}

      {/* MENU PRINCIPAL */}
      <List sx={{ flexGrow: 1 }}>
            {menu
              .filter((item) => {
                if (planoUsuario === "pessoal" && item.id === "usuarios") return false;
                if (!Array.isArray(item.tiposPermitidos)) return true;
                return item.tiposPermitidos.includes(tipoUsuario) &&
                  (!item.somenteAdminPrincipal || podeAcessarItem(item));
              })
              .map((item) => {
              if (item.id === "ensaios" && item.children) {
                return (
                  <ListItemButton key={item.id} onClick={() => setOpenEnsaiosDialog(true)}>
                    <ListItemIcon sx={{ color: "white" }}>
                      {renderMenuIcon(item)}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{ color: "white", fontWeight: 600 }}
                    />
                  </ListItemButton>
                );
              }

              // 🔵 ITEM COM SUBMENU
              if (item.children) {

                const [openSub, setOpenSub] = React.useState(false);

                return (
                  <Box key={item.id}>

                    <ListItemButton onClick={() => setOpenSub(prev => !prev)}>
                      <ListItemIcon sx={{ color: "white" }}>
                        {renderMenuIcon(item)}
                      </ListItemIcon>

                      <ListItemText
                        primary={item.label}
                        primaryTypographyProps={{
                          color: "white",
                          fontWeight: 600
                        }}
                      />

                      {openSub ? (
                        <ExpandLessIcon sx={{ color: "white" }} />
                      ) : (
                        <ExpandMoreIcon sx={{ color: "white" }} />
                      )}
                    </ListItemButton>

                    <Collapse in={openSub} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>

                        {item.children
                          .filter((child) => {
                            if (!Array.isArray(child.tiposPermitidos)) return true;
                            return child.tiposPermitidos.includes(tipoUsuario) &&
                              (!child.somenteAdminPrincipal || podeAcessarItem(child));
                          })
                          .map((child) => {

                          const ativo = location.pathname === child.path;

                          return (
                            <ListItemButton
                              key={child.id}
                              component={Link}
                              to={child.path}
                              sx={{ pl: 4 }}
                              onClick={() => isMobile && toggle()}
                            >
                              <ListItemIcon sx={{ color: "white" }}>
                                {child.icon && <child.icon />}
                              </ListItemIcon>

                              <ListItemText
                                primary={child.label}
                                primaryTypographyProps={{
                                  color: "white",
                                  fontWeight: ativo ? 700 : 500
                                }}
                              />
                            </ListItemButton>
                          );
                        })}

                      </List>
                    </Collapse>
                  </Box>
                );
              }

              // 🔵 ITEM NORMAL
              const ativo = location.pathname === item.path;
              const destacado = item.destaque === true;

              return (
                <ListItemButton
                  key={item.id}
                  component={Link}
                  to={item.path}
                  onClick={() => isMobile && toggle()}
                  sx={{
                    mx: destacado ? 1 : 0,
                    my: destacado ? 0.5 : 0,
                    borderRadius: destacado ? 1.5 : 0,
                    background: destacado
                      ? "linear-gradient(135deg, #fff8e1 0%, #ffca28 100%)"
                      : "transparent",
                    boxShadow: destacado ? "0 4px 14px rgba(0,0,0,0.22)" : "none",
                    "&:hover": {
                      background: destacado ? "#ffd54f" : "rgba(255,255,255,0.08)",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: destacado ? "#0d47a1" : "white" }}>
                    {renderMenuIcon(item)}
                  </ListItemIcon>

                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      color: destacado ? "#0d47a1" : "white",
                      fontWeight: destacado || ativo ? 800 : 500
                    }}
                  />
                </ListItemButton>
              );
            })}
          </List>
    </Box>
  );

  return (
  <>
    {/* BOTÃO ☰ — SOMENTE NO MOBILE */}
    {isMobile && (
      <IconButton
        onClick={toggle}
        sx={{
          position: "fixed",
          top: 7,
          left: 12,
          zIndex: 1300,
          background: "#0f72cf",
          color: "white",
          "&:hover": {
            background: "#0c63b8",
          },
        }}
      >
        <MenuIcon />
      </IconButton>
    )}

    {/* SIDEBAR */}
    <Drawer
  variant={isMobile ? "temporary" : "permanent"}
  open={open}
  onClose={toggle}
  ModalProps={{ keepMounted: true }}
  sx={{
    "& .MuiDrawer-paper": {
      width: drawerWidth,
      background: "#0f72cf",
      color: "white",
      border: "none",

     top: "60px",
height: "calc(100vh - 60px)",
zIndex: 1100,
    },
  }}
>

      {drawerContent}
    </Drawer>

    <Dialog
      open={openEnsaiosDialog}
      onClose={() => setOpenEnsaiosDialog(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle sx={{ pb: 1.2 }}>
        <Typography fontWeight={900} fontSize={22}>Ensaios</Typography>
        <Typography color="text.secondary" fontSize={13}>
          Escolha uma categoria ou busque pelo nome do ensaio.
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ background: "#f8fafc", p: { xs: 2, sm: 3 } }}>
        <Stack spacing={2}>
          <Box
            sx={{
              display: "grid",
              gap: 1,
              gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
            }}
          >
            {[
              { id: "concreto", label: "Concreto", icon: ScienceIcon },
              { id: "solos", label: "Solos", icon: TerrainIcon },
              { id: "asfalto", label: "Asfalto", icon: AddRoadIcon },
            ].map((categoria) => {
              const ativa = categoriaEnsaios === categoria.id;
              const IconeCategoria = categoria.icon;
              const totalCategoria = ensaiosPermitidos.filter(
                (ensaio) => (ensaio.categoria || "concreto") === categoria.id
              ).length;

              return (
                <Button
                  key={categoria.id}
                  onClick={() => setCategoriaEnsaios(categoria.id)}
                  variant="outlined"
                  sx={{
                    bgcolor: ativa ? "#0f72cf" : "#fff",
                    borderColor: ativa ? "#0f72cf" : "#d7e3f3",
                    borderRadius: 1.2,
                    boxShadow: ativa ? "0 6px 14px rgba(15, 114, 207, 0.22)" : "none",
                    color: ativa ? "#fff" : "#0f172a",
                    justifyContent: "flex-start",
                    minHeight: 54,
                    px: 1.5,
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: ativa ? "#0c63b8" : "#eef6ff",
                      borderColor: "#0f72cf",
                    },
                  }}
                >
                  <Box sx={{ alignItems: "center", display: "flex", gap: 1.2, width: "100%" }}>
                    <Box
                      sx={{
                        alignItems: "center",
                        bgcolor: ativa ? "rgba(255,255,255,0.18)" : "#eef6ff",
                        borderRadius: 1,
                        display: "flex",
                        height: 34,
                        justifyContent: "center",
                        width: 34,
                      }}
                    >
                      <IconeCategoria fontSize="small" />
                    </Box>
                    <Box sx={{ lineHeight: 1.15, textAlign: "left" }}>
                      <Typography fontWeight={800} fontSize={14}>{categoria.label}</Typography>
                      <Typography fontSize={11} sx={{ color: ativa ? "rgba(255,255,255,0.82)" : "text.secondary" }}>
                        {totalCategoria} ensaio{totalCategoria === 1 ? "" : "s"}
                      </Typography>
                    </Box>
                  </Box>
                </Button>
              );
            })}
          </Box>

          <TextField
            autoFocus
            size="small"
            placeholder="Buscar ensaio"
            value={buscaEnsaios}
            onChange={(event) => setBuscaEnsaios(event.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                bgcolor: "#fff",
                borderRadius: 1,
              },
            }}
            fullWidth
          />

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(auto-fit, minmax(260px, 1fr))" },
              gap: 1.2,
            }}
          >
            {ensaiosFiltrados.map((ensaio) => {
              const Icone = ensaio.icon;
              const emBreve =
                !AMBIENTE_LOCAL &&
                ["Caracterização Asfalto", "Traço CBUQ"].includes(ensaio.label);

              return (
                <Box
                  key={ensaio.id}
                  onClick={() => {
                    if (emBreve) return;
                    abrirEnsaio(ensaio.path);
                  }}
                  sx={{
                    alignItems: "center",
                    bgcolor: "#fff",
                    border: "1px solid #d7e3f3",
                    borderRadius: 1,
                    cursor: emBreve ? "default" : "pointer",
                    display: "grid",
                    gap: 1.2,
                    gridTemplateColumns: "42px minmax(0, 1fr)",
                    minHeight: 66,
                    p: 1.2,
                    textAlign: "left",
                    transition: "120ms ease",
                    "&:hover": {
                      borderColor: emBreve ? "#d7e3f3" : "#0f72cf",
                      boxShadow: emBreve ? "none" : "0 8px 18px rgba(15, 23, 42, 0.12)",
                      transform: emBreve ? "none" : "translateY(-1px)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      bgcolor: "#eef6ff",
                      borderRadius: 1,
                      color: "#0f72cf",
                      display: "flex",
                      height: 42,
                      justifyContent: "center",
                      width: 42,
                    }}
                  >
                    {Icone ? <Icone /> : <ScienceIcon />}
                  </Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      fontWeight={800}
                      sx={{
                        color: "#1f2937",
                        fontSize: 15,
                        lineHeight: 1.22,
                        overflowWrap: "anywhere",
                      }}
                    >
                      {ensaio.label}
                    </Typography>
                    {(emBreve || ensaio.subtitulo) && (
                      <Typography
                        color="text.secondary"
                        sx={{ fontSize: 10, lineHeight: 1.15, mt: 0.25 }}
                      >
                        {emBreve ? "Em breve" : ensaio.subtitulo}
                      </Typography>
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>

          {!ensaiosFiltrados.length && (
            <Typography color="text.secondary" textAlign="center">
              Nenhum ensaio encontrado.
            </Typography>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  </>
);

}
